<template>
   <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
      <template #button-content>         
         <span v-if="hasLabel">Condividi</span>
         <svg alt="Condividi" class="icon icon-primary mr-1"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="@/assets/img/sprite.svg#it-share"></use></svg><span class="sr-only">Condividi</span>
      </template>               
      <b-dropdown-item v-bind:href="`https://www.facebook.com/sharer/sharer.php?m2w&amp;u=${myUrl}`" target="_blank">
         <svg class="icon icon-primary mr-1"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="@/assets/img/sprite.svg#it-facebook"></use></svg> 
         Facebook
      </b-dropdown-item>
      <b-dropdown-item v-bind:href="`https://twitter.com/home?status=${myUrl}`" target="_blank">
         <svg class="icon icon-primary mr-1"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="@/assets/img/sprite.svg#it-twitter"></use></svg> 
         Twitter
      </b-dropdown-item>
      <b-dropdown-item v-bind:href="`https://www.linkedin.com/sharing/share-offsite/?url=${myUrl}`" target="_blank">
         <svg class="icon icon-primary mr-1"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="@/assets/img/sprite.svg#it-linkedin"></use></svg> 
         Linkedin
      </b-dropdown-item>
      <b-dropdown-item  v-bind:href="`mailto:?subject=#&amp;body=${myUrl}`" target="_blank">
         <svg class="icon icon-primary mr-1"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="@/assets/img/sprite.svg#it-mail"></use></svg> 
         Invia articolo
      </b-dropdown-item>
   </b-dropdown>   
</template>
<script>
export default {
   name: "shareArea",
   components: {
   },
   props: {
      type: {
         type: Boolean,
         default: true,
         description: "Should print 'Condividi' in front of icon"
      },
      url: {
        type: String,
        description: "Should print 'Condividi' in front of icon"
      },
      hasLabel: {
        type: Boolean
      }
   },
   data() {
     return {      
        myUrl: this.getCurrentUrl()
     }
   }, 
   methods:{
      getCurrentUrl(){
          //!== undefined? window.location.origin + this.getCurrentUrl() : window.location
         if(this.$props.url === undefined){
            return window.location;
         }
         else{
            return window.location.origin + encodeURIComponent(this.$props.url);
         }
      }   
   } 
};
</script>            
<style>
.btn.dropdown-toggle.btn-link{
   padding: 1px 6px !important;
   flex:unset;
}
.read-more + .icon{
   margin-left: 8px;
   fill: #003594;
   width: 16px;
   height: 16px;
   flex-shrink: 0;
}
</style>